import { NotificationData } from "@mantine/notifications";
import { faCheck, faExclamation, faXmark } from "@fortawesome/pro-solid-svg-icons";
import { Icon } from "../icon";

export const LOADING_NOTIFICATION_CONFIG: Omit<NotificationData, "message"> = {
    loading: true,
    autoClose: false,
    withCloseButton: false,
};

export const SUCCESS_NOTIFICATION_CONFIG: Omit<NotificationData, "message"> = {
    color: "green",
    style: {
        "--notification-color": "var(--mantine-color-success-filled)",
    },
    icon: <Icon icon={faCheck} />,
    withCloseButton: false,
    loading: false,
    autoClose: 4000,
};

export const ERROR_NOTIFICATION_CONFIG: Omit<NotificationData, "message"> = {
    color: "red",
    style: {
        "--notification-color": "var(--mantine-color-error-filled)",
    },
    icon: <Icon icon={faXmark} />,
    withCloseButton: false,
    loading: false,
    autoClose: 4000,
};

export const WARNING_NOTIFICATION_CONFIG: Omit<NotificationData, "message"> = {
    color: "yellow",
    style: {
        "--notification-color": "var(--mantine-color-yellow-filled)",
    },
    icon: <Icon icon={faExclamation} />,
    withCloseButton: true,
    loading: false,
    autoClose: 4000,
};
